import React, { FC } from 'react'
import styled from 'styled-components'
import { darkGrayColor } from 'uiComponents/constants/colors'
import { fsXS, fwBold } from 'uiComponents/constants/typography'

export const DropDetailsInformationText: FC<{
  informationText: string | undefined
}> = ({ informationText }) => {
  if (!informationText) {
    return null
  }

  return <InformationContainer>{informationText}</InformationContainer>
}

const InformationContainer = styled.section`
  padding: 26px 18px;
  font-size: ${fsXS}px;
  line-height: 1.4;
  ${fwBold};
  color: ${darkGrayColor};
`
